import {
  FormControl,
  FormControlLabel,
  FormLabel,
  GridLegacy as Grid,
  Radio,
  RadioGroup,
} from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SurveyQuestion } from '../types';

import { useSxStyles } from './useStyles';

type Props = {
  question: SurveyQuestion;
  control: Control;
};

export const Scale: React.FC<Props> = ({ control, question }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const options = Array.from(new Array(5));

  return (
    <Grid
      container
      item
      xs={12}
      direction="row"
      key={question.id}
      justifyContent="space-between"
    >
      <FormControl sx={sxStyles.formControl} fullWidth required>
        <Grid item sx={{ ...sxStyles.question, ...sxStyles.stretch }}>
          <FormLabel sx={sxStyles.formControlLabel}>{question.text}</FormLabel>
        </Grid>
        <Grid item sx={{ ...sxStyles.stretch, ...sxStyles.scale }}>
          {t('label_disagree')}
          <Controller
            control={control}
            name={`${question.id}`}
            rules={{
              required: `${t('laThisRequired')}`,
            }}
            defaultValue=""
            render={({ field }) => (
              <RadioGroup
                {...field}
                aria-label={`${question.type} question`}
                name={`${question.id}`}
                sx={{ ...sxStyles.group, ...sxStyles.inlineGroup }}
              >
                {options.map((_c, index) => (
                  <FormControlLabel
                    key={index}
                    value={`${index + 1}`}
                    control={<Radio color="primary" sx={sxStyles.radio} />}
                    label={index + 1}
                  />
                ))}
              </RadioGroup>
            )}
          />
          {t('label_agree')}
        </Grid>
      </FormControl>
    </Grid>
  );
};
